import { FormControlLabel, InputLabel, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Button from "@mui/material/Button";
import Partslist from "../Partslist";
import Checkbox from "@mui/material/Checkbox";
import { Container, DialogActions, DialogContent, DialogTitle, Link } from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Grid from "@material-ui/core/Grid";
import ExhibitionDetails from "../ExhibitionDetails";
import I18N from "../../../../../../Wirtschaftswunder/oc-modules/oc-I18N";
import CustomInput from "../CustomInput";
import CustomTextarea from "../CustomTextarea";
import Divider from "@mui/material/Divider";
import CustomSelect from "../CustomSelext";
import { pureHTML } from "../../atoms/pureHTML";
import LogoSvg from "../../styles/images/logo.svg";

export default function RequestDialogClosure() {
  const closeRequestDialog = () => {
    APP.arrangement.setDialog(undefined);
  };

  const sendRequest = async () => {
    console.log("sending request");
    APP.updateConfiguration();
    APP.save({
      callback: async (configuration) => {
        const pdfURL =
          APP.wkfgBackendApi.getPdfUrl(configuration.Code) +
          `?mail=true&lang=${I18N.getLanguage()}`;
        try {
          await fetch(pdfURL);
        } catch (e) {
          console.error(e);
        }
      },
      quiet: true,
      preferUpdate: true,
      noFotoSnapshots: false,
      skipURLUpdate: true,
      modifyBeforeWrite: (configuration) => {
        configuration.Inspiration = false;
      },
    });
    closeRequestDialog();
  };

  const formFields = APP.richMetadata.getFormFields();
  const initArrangementState = () => {
    formFields.forEach((field) => {
      APP.arrangement.state.userData[field.title] = {
        value: "",
        valid: !(field.required || !!field.verificationRegEx),
        required: field.required
      };
    });
  };

  initArrangementState();
  const numberOptions = (min, max) => {
    return _.range(min, max).map((i) => {
      return { label: i };
    });
  };

  const checkEverythingIsValid = () => {
    const everythingIsValid = !_.filter(APP.arrangement.state.userData, (data) => {
      return data.valid !== undefined && data.valid == false && data.required == true;
    }).length;
    APP.arrangement.state.userData.allValid = everythingIsValid;
  }

  const verifyInput = (event, field) => {
    const valid = field.required ? 
      !_.isEmpty(event.target.value) && !!event.target.value.match(
        new RegExp(field.verificationRegEx?.substring(1, field.verificationRegEx.length - 1))
      ) : 
      true;
    APP.arrangement.state.userData[field.title].valid =
      APP.arrangement.state.userData[field.title]?.valid || false;
    if (!!APP.arrangement.state.userData[field.title]?.valid !== valid) {
      APP.arrangement.state.userData[field.title].valid = valid;
      APP.dirty();
    }
    checkEverythingIsValid();
  };

  const updateState = (event, field, filterPattern) => {
    let value = "";
    switch (true) {
      case field.type === "Checkbox":
        value = event.target.checked;
        break;
      case field.type === "Select":
        value = event;
        break;
      default:
        value = event.target.value;
        break;
    }
    if (filterPattern) {
      value = value.replace(new RegExp(filterPattern), "");
    }
    console.log(value);
    APP.arrangement.state.userData[field.title].value = value;

    if(field.type == "Checkbox") {
      APP.arrangement.state.userData[field.title].valid = field.required ? value : true;
    }
    if(field.type == "Select") {
      APP.arrangement.state.userData[field.title].valid = field.required ? !!value : true;
    }
    checkEverythingIsValid();
    APP.dirty();
  };

  return function RequestDialog() {
    return (
      <>
        <DialogTitle style={{ padding: "12px" }}>
          <Box style={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton size="large" onClick={closeRequestDialog} color="black">
              <CancelIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent style={{ padding: 0 }}>
          <Container>
            <Box sx={{ display: "flex", marginBottom: "30px" }}>
              <Box
                display={{
                  xs: "none",
                  lg: "block",
                  marginRight: "40px",
                  maxWidth: "170px",
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", width: "100%", height: "100%" }}>
                  <img style={{ width: "100%", height: "auto" }} src={APP.richMetadata.getLogo()} />
                </Box>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box
                  sx={{
                    color: "#3A415A",
                    fontSize: "1.3rem",
                    fontWeight: "700",
                    marginBottom: "10px",
                  }}
                >
                  {I18N("RequestDialog:Heading")}
                </Box>
                <Box
                  display={{
                    xs: "block",
                    lg: "none",
                    marginTop: "10px",
                    marginBottom: "20px",
                    maxWidth: "110px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", width: "100%", height: "100%" }}
                  >
                    <img style={{ width: "100%", height: "auto" }} src={LogoSvg} />
                  </Box>
                </Box>
                <Box sx={{ color: "#3A415A", fontSize: "1.2rem", marginBottom: "4px" }}>
                  {I18N("RequestDialog:Address")}
                </Box>
                <Box sx={{ marginBottom: "10px" }}>
                  <Link href={I18N("RequestDialog:Link url")} style={{ color: "#3A415A" }}>
                    {I18N("RequestDialog:Link")}
                  </Link>
                </Box>
                <Box sx={{ color: "#3A415A", fontSize: "1.2rem", marginBottom: "10px" }}>
                  {I18N("RequestDialog:SalesRepresentative")}
                </Box>
                <Box sx={{ marginBottom: "4px" }}>
                  <Link href={I18N("RequestDialog:Contact Link url")} style={{ color: "#3A415A" }}>
                    {I18N("RequestDialog:Contact Link")}
                  </Link>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Box sx={{ color: "#3A415A", marginBottom: 0 }}>
                    {I18N("RequestDialog:Tel")}
                  </Box>
                  <Box sx={{ color: "#3A415A", marginBottom: 0 }}>
                    {I18N("RequestDialog:Fax")}
                  </Box>
                </Box>
              </Box>
            </Box>

            <Divider sx={{ marginBottom: "10px" }} />

            <Box sx={{ marginBottom: "20px" }}>
              <Box style={{ color: "#3A415A", fontSize: '2.125rem', fontWeight: 700 }}>
                {I18N("Quotation")}
              </Box>
            </Box>

            <Box sx={{ marginBottom: "20px", fontSize: "1.3rem" }}>
              <span style={{ color: "#3A415A" }}>{I18N("Quotation Subline")}</span>
              <span style={{ color: "#C91113", fontWeight: 700 }}> #{APP.configuration.Code}</span>
            </Box>

            <ExhibitionDetails exhibition={APP.arrangement.state.exhibition} />

            <Partslist />
            <Typography component={Box} variant={"h4"} style={{ marginBottom: "24px" }}>
              {I18N("RequestDialog:Information")}
            </Typography>
            <Typography component={Box} style={{ marginBottom: "37px", fontWeight: "700" }}>
              * {I18N("RequestDialog:Required")}
            </Typography>
            <Grid container spacing={2}>
              {formFields.length > 0 &&
                formFields.map(
                  (field) =>
                    (field.type === "Text" && (
                      <Grid item xs={12} md={field.Singlerow ? 12 : 6}>
                        <CustomInput
                          key={field.title}
                          label={field.label}
                          placeholder={field.placeholder}
                          required={field.required}
                          className={
                            !APP.arrangement.state.userData[field.title]?.valid &&
                            APP.arrangement.state.userData[field.title]?.value
                              ? "error"
                              : ""
                          }
                          onChange={(event) => {
                            updateState(event, field);
                            verifyInput(event, field);
                          }}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                    )) ||
                    (field.type === "Textarea" && (
                      <Grid item xs={12} md={field.Singlerow ? 12 : 6}>
                        <CustomTextarea
                          key={field.title}
                          label={field.label}
                          placeholder={field.placeholder}
                          required={field.required}
                          className={
                            !APP.arrangement.state.userData[field.title]?.valid &&
                            APP.arrangement.state.userData[field.title]?.value
                              ? "error"
                              : ""
                          }
                          onChange={(event) => {
                            updateState(event, field);
                            verifyInput(event, field);
                          }}
                          multiline={true}
                          minRows="5"
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                    )) ||
                    (field.type === "Email" && (
                      <Grid item xs={12} md={field.Singlerow ? 12 : 6}>
                        <CustomInput
                          key={field.title}
                          label={field.label}
                          placeholder={field.placeholder}
                          required={field.required}
                          error={!APP.arrangement.state.userData[field.title]?.valid}
                          className={
                            !APP.arrangement.state.userData[field.title]?.valid &&
                            APP.arrangement.state.userData[field.title]?.value
                              ? "error"
                              : ""
                          }
                          onChange={(event) => {
                            updateState(event, field);
                            verifyInput(event, field);
                          }}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                    )) ||
                    (field.type === "Phone" && (
                      <Grid item xs={12} md={field.Singlerow ? 12 : 6}>
                        <CustomInput
                          key={field.title}
                          label={field.label}
                          placeholder={field.placeholder}
                          required={field.required}
                          value={APP.arrangement.state.userData[field.title]?.value}
                          error={!APP.arrangement.state.userData[field.title]?.valid}
                          className={
                            !APP.arrangement.state.userData[field.title]?.valid &&
                            APP.arrangement.state.userData[field.title]?.value
                              ? "error"
                              : ""
                          }
                          onChange={(event) => {
                            updateState(event, field, "[^(\\d|\\+|e?|x?|t?|\\s|\\-|#+)]");
                            verifyInput(event, field);
                          }}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                    )) ||
                    (field.type === "Select" && (
                      <Grid item xs={12} md={field.Singlerow ? 12 : 6}>
                        <Box sx={{ position: "relative", width: "100%" }}>
                          <InputLabel sx={{ marginBottom: "8px", color: "#3A415A" }}>
                            {field.label} {field.required && <> *</>}
                          </InputLabel>
                          <CustomSelect
                            key={field.title}
                            options={field.options}
                            onChangeFn={(event) => updateState(event, field)}
                            placement={"bottom-start"}
                            className={
                              !APP.arrangement.state.userData[field.title]?.valid &&
                              (APP.arrangement.state.userData[field.title]?.value ===
                                field.options[0] ||
                                !APP.arrangement.state.userData[field.title]?.value)
                                ? "error"
                                : ""
                            }
                            label={field.placeholder ? field.placeholder : field.label}
                            placeholder={field.placeholder}
                            sx={{
                              width: "100%",
                              margin: "auto",
                              border: "1px solid #939599",
                              padding: "8px",
                              borderRadius: "4px",
                              "&:hover": {
                                border: "1px solid #000",
                              },
                            }}
                          />
                        </Box>
                      </Grid>
                    )) ||
                    (field.type === "Checkbox" && (
                      <Grid item xs={12} md={field.Singlerow ? 12 : 6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              key={field.title}
                              label={field.label}
                              checked={!!APP.arrangement.state.userData[field.title]?.value}
                              onChange={(event) => updateState(event, field)}
                            />
                          }
                          label={<pureHTML dangerouslySetInnerHTML={{__html: field.longtext}} />}
                          sx={{
                            alignItems: 'flex-start',
                            '.MuiCheckbox-root': {
                              padding: '0 9px 0 0 !important',
                              marginLeft: '0 !important'
                            }
                          }}
                          className={'request-checkbox'}
                          required={field.required}
                        />
                      </Grid>
                    )) ||
                    (field.type === "Placeholder" && (
                      <Grid
                        item
                        xs={field.Singlerow ? 12 : 6}
                        sx={{
                          [field.Singlerow]: {
                            display: "none",
                          },
                          [theme.breakpoints.up("lg")]: {
                            display: "block",
                          },
                        }}
                      />
                    ))
                )}
            </Grid>
          </Container>
        </DialogContent>
        <DialogActions>
          <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <Button
              className="removeInterior"
              onClick={sendRequest}
              sx={{
                width: "100%",
                maxWidth: "274px",
                fontWeight: "700",
                "&:disabled": {
                  opacity: "50%",
                },
              }}
              variant="contained"
              color="primary"
              disabled={!APP.arrangement.state.userData?.allValid}
            >
              {I18N("Send request")}
            </Button>
          </Box>
        </DialogActions>
      </>
    );
  };
}
